import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { fetchProducts } from '../actions/ProductActions.js';
import { fetchFilteredProducts } from "../actions/FilterActions";
import { ProductCarouselSkeleton } from "./HomeSkeletons";
import ProductCard from "./ProductCard.jsx";
import { useNavigate } from "react-router-dom";
import { SelectTrendingProducts } from "../selectors/ProductSelector.js";
import "../styles/bestsellers.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
const Trending = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, filteredProducts } = useSelector(
    (state) => state.filters
  );
  // const trendingProducts = useSelector(SelectTrendingProducts);
  const scrollRef = useRef(null);

  useEffect(() => {
    dispatch(
      fetchFilteredProducts({
        tags: ["HOT DEAL"],
        page: 1,
        status: "published",
        pagination: 30,
      })
    );
  }, [dispatch]);

  const handleProductClick = (product) => {
    navigate(`/product/${product.slug || product.product_id}`);
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  if (loading)
    return <ProductCarouselSkeleton title="Trending" variant="bestsellers" />;
  if (error) return <div>Error: {error}</div>;

  if (filteredProducts && filteredProducts.length === 0) {
    return (
      <div className="bestsellers-section">
        <h3 className="bestsellers-title">Trending</h3>
        <div className="no-products-message">
          No trending products available at the moment.
        </div>
      </div>
    );
  }

  return (
    <div className="bestsellers-section">
      <div className="bestsellers-title-and-chevron">
        <h3 className="bestsellers-title">Trending</h3>
        <div className="bestsellers-chevrons">
          <button className="nav-arrow" onClick={scrollLeft}>
            <FaChevronLeft />
          </button>
          <button className="nav-arrow" onClick={scrollRight}>
            <FaChevronRight />
          </button>
        </div>
      </div>
      <div className="bestsellers-grid" ref={scrollRef}>
        {filteredProducts.map((product) => (
          <div
            key={product.product_id}
            className="bestsellers-product-item"
            onClick={() => handleProductClick(product)}
          >
            <ProductCard product={product} preferredTag="HOT DEAL" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Trending;
